module.exports = __webpack_public_path__ + "static/media/ic_location_deactivate.26c896b2.svg";